import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../hoc/Loading/Loading';
import axios from '../../axios';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import LinkedChartItem from './LinkedChartItem';
import * as url from '../../utils/url';
import { Container, Row, Col } from 'reactstrap';

class LinkedToolItem extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      tools:[]
     }
  }

  getAttachedItems=()=>{
    // let{linkedTools,taskId}=this.props
    // let link_ids = linkedTools.map(e=>e.itemId)
    // let payload = {
    //   linkedTools:link_ids,
    //   taskId
    // }
    // if(linkedTools && linkedTools.length>0) {
    //   axios.post(url.fetchAttachedCharts, payload ).then( ({ data }) => {
    //     let result = data.data 
    //     let mod = result.map(e=> {
    //       let other = linkedTools.find(el=> el.itemId == e._id)
    //       return { attachedDate: other.date, ...e}
    //     })
    //     this.setState({tools:[...mod]})
    //   }) 
    // }
  }
  
  componentDidMount(){
    // this.getAttachedItems()
  }

  componentDidUpdate(prevProps) {
    // let current_ch = this.props.linkedTools.length
    // let prev_ch = prevProps.linkedTools.length
    // if(current_ch!=prev_ch){
    //   this.getAttachedItems()
    // }
  }
 
  renderView=()=>{
    let{tool}=this.props
    if(tool){
      return [
        <tr className="map-column-table row pl20 pr20" key={tool._id} >
                                
          <td >
            {tool.name}
          </td>
                              
          <td >
             test 1                     
          </td>

          <td >
             test 13                    
          </td>

          <td >
             test 4                    
          </td>
        </tr>
      ]
    } else {
      return null
    }
  }


  render() { 
    return  <Fragment >{this.renderView()}</Fragment>
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
  }
}
 
// export default LinkedCharts;
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(LinkedToolItem, axios)));
